/* import __COLOCATED_TEMPLATE__ from './verify-code.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { PhoneFormatter } from 'field-kit';
import assert, { assertInstanceOf } from '@banking/ui/utils/assert';
import { select } from '@banking/ui/services/investments-workflow';
import { userChangeVerificationCodeAction, userClickVerifyAction, userClickResendCodeAction, setOnboardingScreenAction } from '@banking/ui/workflows/investments';
const VALID_CODE_INPUT = /^(\s*|\d+)$/;
let VerifyCode = (_dec = select(state => state.phoneNumber), _dec2 = select(state => state.verificationCodeError), _dec3 = select(state => state.verificationCodeError?.length > 0), _dec4 = select(state => state.toggleButtonLoading), _dec5 = select(state => state.isTwoFactorEnabled), _class = class VerifyCode extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "investmentsWorkflow", _descriptor2, this);
    _initializerDefineProperty(this, "features", _descriptor3, this);
    _defineProperty(this, "formatter", new PhoneFormatter());
    _initializerDefineProperty(this, "phoneNumber", _descriptor4, this);
    _initializerDefineProperty(this, "errorMessage", _descriptor5, this);
    _initializerDefineProperty(this, "showErrorMessage", _descriptor6, this);
    _initializerDefineProperty(this, "isButtonLoading", _descriptor7, this);
    _initializerDefineProperty(this, "isTwoFactorEnabled", _descriptor8, this);
  }
  get description() {
    assert(this.phoneNumber);
    return this.intl.t('banking.checking.onboarding.twoFactor.verifyCode.description', {
      phoneNumber: this.formatter.format(this.phoneNumber)
    });
  }
  get nextScreen() {
    if (this.features.isEnabled('squareinvest/cashtag_linking')) {
      return 'linking';
    } else {
      return 'withholding';
    }
  }
  onInputChange(event) {
    const value = assertInstanceOf(event, CustomEvent).detail.code;
    if (!VALID_CODE_INPUT.test(value)) {
      event.preventDefault();
      return;
    }
    this.investmentsWorkflow.emit(userChangeVerificationCodeAction(value));
    if (value.length === 6) {
      this.investmentsWorkflow.emit(userClickVerifyAction());
    }
  }
  onNextButtonClick() {
    this.investmentsWorkflow.emit(userClickVerifyAction());
  }
  onResendCodeClick() {
    this.investmentsWorkflow.emit(userClickResendCodeAction());
  }
  setOnboardingScreen(newPage) {
    this.investmentsWorkflow.emit(setOnboardingScreenAction(newPage));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "investmentsWorkflow", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "errorMessage", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showErrorMessage", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isButtonLoading", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isTwoFactorEnabled", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onInputChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onNextButtonClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onNextButtonClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onResendCodeClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onResendCodeClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setOnboardingScreen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setOnboardingScreen"), _class.prototype), _class);
export { VerifyCode as default };